var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"color":"#424242","padless":""}},[_c('p',{staticStyle:{"color":"white","justify-items":"center"}},[_vm._v("Created By : Sashin Agrawal ")])])}
var staticRenderFns = []

export { render, staticRenderFns }